import React from "react";
import { Alert, Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Button from "./Button";
import { RuleFolder } from "@mui/icons-material";

type FixedAlertCardProps = {
  message: string;
  showButton?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
};

const FixedAlertCard: React.FC<FixedAlertCardProps> = ({
  message,
  showButton = false,
  buttonText,
  onButtonClick,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        position: "fixed",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1300,
        minWidth: "300px",
        maxWidth: "90%",
      }}
    >
      <Box
        sx={{
          p: 2,
          backgroundColor: "#161D26",
          borderRadius : "10px",
          border: 1,
          borderColor: colors.grey[700],
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="body1" sx={{ pr: 2 }} color="#ffffff">
            {message}
          </Typography>
          {showButton && buttonText && onButtonClick ? (
            <Button
              color="primary"
              removeUpperCase
              onClick={onButtonClick}
              startIcon={<RuleFolder fontSize="small" />}
              sx={{
                // Teal gradient to match the primary action buttons
                // (Add Patient / Search / Continue).
                borderRadius: "10px",
                px: 2,
                whiteSpace: "nowrap",
                background: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
                boxShadow: "0 4px 18px rgba(20,184,166,0.35)",
                "& .MuiTypography-root": { color: "#ffffff" },
                "& .MuiButton-startIcon": { color: "#ffffff" },
                "&:hover": {
                  background: "linear-gradient(135deg, #0d9488 0%, #0f766e 100%)",
                  boxShadow: "0 6px 22px rgba(20,184,166,0.45)",
                },
              }}
            >
              {buttonText}
            </Button>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default FixedAlertCard;
